import cn from "../../../utils/cn";

const Footer = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      "flex md:flex-row md:justify-start flex-col justify-end pt-5 gap-5",
      className
    )}
    {...props}
  />
);

export default Footer;
